















































































import { InterventionApi } from "../api/InterventionApi";
import PhotosViewer from "../core/Files/PhotosViewer.vue";
import moment from "moment";
import { Intervention } from "../models/Intervention";

export default {
    name: "InterventionPhotos",
    components: {
        PhotosViewer,
    },
    props: {
        interventionHash: String,
    },
    data: function () {
        return {
            intervention: null,
            InterventionApi: new InterventionApi(),
        };
    },
    created() {
        let self = this;
        self.InterventionApi.getByHash(self.interventionHash, {
            include: "photos",
        })
            .then(function (intervention) {
                self.intervention = intervention;
            })
            .catch(function (error) {
                swal({
                    title: "Erreur",
                    text: "Intervention non trouvée",
                    type: "error",
                    showConfirmButton: false,
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                });
            });
    },
    computed: {
        datePriseEnCompte(): string {
            return this.intervention.creation_date_str;
        },
        datePrevueIntervention(): string {
            let res = "";

            let date = moment(this.intervention.date_prevue_intervention);

            if (date.isValid()) {
                res =
                    '<i class="fal fa-check"></i> Intervention programmée le ' +
                    date.format("DD/MM/YYYY");
                if (this.intervention.horaire_debut) {
                    res += " à " + this.intervention.horaire_debut;
                }
            }

            return res;
        },
        ongoing(): boolean {
            return this.intervention.etat === Intervention.EEtat.Ongoing;
        },
        finished(): boolean {
            return (
                this.intervention.etat === Intervention.EEtat.Finished ||
                this.intervention.etat === Intervention.EEtat.Archived
            );
        },
    },
};
